import RejectIconUrl from "assets/icons/reject-red.svg?url";
import WarningIconUrl from "assets/icons/exclamation-round-color.svg?url";

export const CURRENCY = {
  code: "INR",
  name: "Indian Rupee",
  symbol: "₹",
};

export const ENTRY_POINT = {
  name: "sales-purchase-orders",
};

export const FILE_TYPE_MAP = {
  "E-Invoice": {
    entity: "invoice",
    key: "invc_id",
    label: "E-Invoice",
  },
  "E-Way Bill": {
    entity: "ewb",
    key: "ewaybill_id",
    label: "E-Way Bill",
  },
  "Purchase Order": {
    entity: "purchaseOrder",
    key: "po_id",
    label: "Purchase Order",
  },
  "Purchase Bill": {
    entity: "purchaseBill",
    key: "bill_id",
    label: "Purchase Bill",
  },
  "Proof of Delivery": {
    entity: "pod",
    key: "pod_id",
    label: "Proof of Delivery",
  },
  "Credit Note": {
    entity: "creditNote",
    key: "cn_id",
    label: "Credit Note",
  },
  "Debit Note": {
    entity: "debitNote",
    key: "dn_id",
    label: "Debit Note",
  },
  "Quality Check": {
    entity: "qualityCheck",
    key: "qc_id",
    label: "Quality Check",
  },
  "Deal Terms": {
    entity: "dealSetting",
    key: "deal_setting_id",
    label: "Deal Terms",
  },
  "Payment Advice": {
    entity: "customerPayment",
    key: "cp_id",
    label: "Payment Advice",
  },
};

export const PRODUCT_MARGIN = {
  default: {
    min: 0.3,
    max: 2,
  },
  range: {
    min: 0.3,
    max: 9.9,
  },
};

export const FORM_INFO = "✍️ Fields marked with * are mandatory";

export const NO_OPTIONS_TEXT = {
  bills:
    "No eligible Purchase bills found. Please check if there are any active Purchase bills.",
  invoices:
    "No eligible invoices found. Please check if there are any active PODs",
  refInvoices:
    "No eligible invoices found. Please check if there are any invoices linked with active POD",
};

export const ICON_PATH = {
  negative: `img:${RejectIconUrl}`,
  warning: `img:${WarningIconUrl}`,
};
